import { Box, Button, Icon, Link } from '@mui/material'
import React from 'react'

import { openClearFeed } from '@/app/service/clearfeed/utils'

type Props = {}

const QuickActions: React.FC<Props> = () => {
  const openChat = () => openClearFeed()

  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      <Button variant="outlined" startIcon={<Icon>chat_bubble_outlined</Icon>} onClick={openChat}>
        Live chat
      </Button>
      <Button
        component={Link}
        href="mailto:help@engagespark.com"
        startIcon={<Icon>mail_outlined</Icon>}
        target="_blank"
        variant="outlined"
      >
        Email
      </Button>
      <Button
        component={Link}
        href="https://outlook.office.com/bookwithme/user/27a2a4855e6246f7beba5e086fcf11e2@engageSPARK.com?anonymous&ismsaljsauthenabled&ep=plink"
        startIcon={<Icon>event_available_outlined</Icon>}
        target="_blank"
        variant="outlined"
      >
        Schedule a demo
      </Button>
    </Box>
  )
}

export default QuickActions
